export const countries = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Argentina', 'Armenia', 'Australia',
  'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium',
  'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil',
  'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde',
  'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo (Brazzaville)',
  'Congo (Kinshasa)', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark',
  'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea',
  'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia',
  'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau',
  'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq',
  'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati',
  'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein',
  'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta',
  'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco',
  'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal',
  'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia',
  'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru',
  'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis',
  'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe',
  'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia',
  'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain',
  'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan',
  'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey',
  'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom',
  'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam',
  'Yemen', 'Zambia', 'Zimbabwe'
];

export const relationshipTypes = [
  // Family Relations
  'Spouse',
  'Wife',
  'Husband',
  'Child',
  'Son',
  'Daughter',
  'Parent',
  'Father',
  'Mother',
  'Sibling',
  'Brother',
  'Sister',
  'Grandparent',
  'Grandfather',
  'Grandmother',
  'Grandchild',
  'Grandson',
  'Granddaughter',
  'Uncle',
  'Aunt',
  'Nephew',
  'Niece',
  'Cousin',
  'In-Law',
  'Father-in-Law',
  'Mother-in-Law',
  'Son-in-Law',
  'Daughter-in-Law',
  'Brother-in-Law',
  'Sister-in-Law',
  'Step-Parent',
  'Step-Father',
  'Step-Mother',
  'Step-Child',
  'Step-Son',
  'Step-Daughter',
  'Step-Sibling',
  'Step-Brother',
  'Step-Sister',
  'Half-Sibling',
  'Half-Brother',
  'Half-Sister',
  'Adopted Child',
  'Adoptive Parent',
  'Foster Child',
  'Foster Parent',
  'Legal Guardian',
  'Ward',
  // Professional Relations
  'Business Partner',
  'Business Associate',
  'Co-Owner',
  'Shareholder',
  'Director',
  'Trustee',
  'Beneficiary',
  'Legal Representative',
  'Attorney',
  'Financial Advisor',
  'Accountant',
  'Employee',
  'Employer',
  'Colleague',
  'Subordinate',
  'Superior',
  // Personal Relations
  'Friend',
  'Close Friend',
  'Domestic Partner',
  'Ex-Spouse',
  'Ex-Partner',
  'Fiancé',
  'Fiancée',
  'Romantic Partner',
  'Significant Other',
  // Other Relations
  'Associate',
  'Acquaintance',
  'Neighbor',
  'Household Member',
  'Dependent',
  'Caregiver',
  'Other'
];